namespace pixi_ui {
    (PIXI as any).ui = pixi_ui;
}

declare module 'pixi-ui' {
    // @ts-ignore
    export = pixi_ui;
}
